var _g, _g2, _g3, _text, _text2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDualVerticalReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_234_1",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 234 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 301,
    height: 180,
    viewBox: "0 0 301 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_1485",
    "data-name": "\\u9577\\u65B9\\u5F62 1485",
    fill: "#f0f0f0",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 180,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 300,
    height: 179,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_1488",
    "data-name": "\\u9577\\u65B9\\u5F62 1488",
    transform: "translate(71 8)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173,
    height: 69,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_1486",
    "data-name": "\\u9577\\u65B9\\u5F62 1486",
    transform: "translate(71 102)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 173,
    height: 69,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\u9818\\u53CE\\u66F81",
    transform: "translate(126 35)",
    fill: "#707070",
    fontSize: 16,
    fontFamily: "HiraginoSans-W6, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\u9818\u53CE\u66F81"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "\\u9818\\u53CE\\u66F82",
    transform: "translate(126 129)",
    fill: "#707070",
    fontSize: 16,
    fontFamily: "HiraginoSans-W6, Hiragino Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "\u9818\u53CE\u66F82"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1008",
    "data-name": "\\u30D1\\u30B9 1008",
    d: "M0,0H258",
    transform: "translate(29 90)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    strokeDasharray: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualVerticalReceipt);
export default __webpack_public_path__ + "static/media/dual_vertical_receipt.a384d2cb7ff4e6998529087a78909030.svg";
export { ForwardRef as ReactComponent };